// import { fromJS, Map } from 'immutable';

import findIndex from 'lodash/findIndex';

export const initialState = {
	list: {
		data: [],
		loading: true
	}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case 'GET_METADATA_LIST_REQUEST':
			return { list: { ...initialState.list }, ...state };
		case 'GET_METADATA_LIST_SUCCESS': {
			const data = [...state.list.data, ...action.payload];
			return { ...state, list: { data, loading: false } };
		}
		case 'UPDATE_METADATA_LIST_REQUEST':
			return { ...state, list: { ...initialState.list } };
		case 'UPDATE_METADATA_LIST_SUCCESS': {
			const { alias } = action.payload;
			const { data } = state.list;
			if (alias) {
				const index = findIndex(data, e => e.alias === alias);
				if (index > 0) {
					data[index] = action.payload;
				}
			}
			return { ...state, list: { data: [...data], loading: false } };
		}
		default:
			return state;
	}
};
